export var CLASS_ACTIVE = 'is-active';
export var CLASS_OPEN = 'is-open';
export var CLASS_HIDDEN = 'is-hidden';
export var CLASS_VISIBLE = 'is-visible';
export var CLASS_FADE_IN = 'is-fade-in';
export var CLASS_FADE_OUT = 'is-fade-out';
export var CLASS_STICKY = 'is-sticky';
export var CLASS_FIXED = 'is-fixed';
export var CLASS_STUCK = 'is-stuck';
export var CLASS_UNAVAILABLE = 'is-unavailable';
export var CLASS_SELECTED = 'is-selected';
export var CLASS_DISABLED = 'is-disabled';
export var CLASS_SCROLL_DISABLED = 'is-scroll-disabled';
export var CLASS_HAS_ERROR = 'has-error';
export var CLASS_MENU_TOGGLE = 'is-menu-open';
export var CLASS_INIT = 'is-initialised';
export var CLASS_SEARCH_OPEN = 'is-search-open';
export var CLASS_MENU_OPEN = 'is-menu-open';
export var CLASS_IS_SUBMENUING = 'is-submenu-open';
export var CLASS_IS_SUBSUBMENUING = 'is-subsubmenu-open';
export var CLASS_OVERLAY_OPEN = 'is-overlay-open';
export var CLASS_MEGANAV_OPEN = 'is-meganav-open';
export var CLASS_PROMOBAR = 'is-promobar';
export var CLASS_IS_CART_OPEN = 'is-cart-open';
export var CLASS_EXPANDED = 'is-expanded';
export var CLASS_HAS_COMPARE = 'has-compare';
export var CLASS_IS_EMPTY = 'is-empty';